import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=9a8ce252&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=9a8ce252&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/mgtpr6vc/mgt-elearning/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a8ce252"]])

export default __exports__